import { IconButton as MuiIconButton } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  root: {
    padding: 8,
    '@media (max-width:768px)': {
      padding: 5,
    },
  },
}));

interface IconButtonProps {
  children: JSX.Element;
  onClick?: () => void;
}

const IconButton = ({ children, onClick }: IconButtonProps) => {
  const classes = useStyles();
  return (
    <MuiIconButton classes={classes} onClick={onClick}>
      {children}
    </MuiIconButton>
  );
};

export default IconButton;
